module.exports = __webpack_public_path__ + "static/media/digitalOcean_logo.a325c3eb.png";